import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import LocationPin from 'assets/svgs/locationPin.svg';
import ProfileIcon from 'assets/svgs/profileIcon.svg';
import { Input, Textarea, ZipForm } from 'shared/components';
import { isEmpty } from 'lodash';
import './ShippingTab.scss';
const MESSAGE_MAX_LENGTH = 360;

class ShippingTab extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.onClearValue = this.onClearValue.bind(this);
    this.onChangeZipForm = this.onChangeZipForm.bind(this);
  }

  onClearValue(name) {
    this.props.onShippingUpdate(name, '');
  }

  onChangeZipForm(address, name, value, error) {
    this.props.onShippingUpdate(name, value, error);
  }

  render() {
    const { tcEvent, shippingAddress, errors } = this.props;

    return (
      <div className="shipping-info-container">
        <h5 className="pb-3">{tcEvent.testingEvent.name}</h5>
        <div className="border-bottom-gray">
          <p className="fw-bold">{this.props.t('requestUpdate.shippingSection.shipTo')}</p>
          <p>
            <span className="pe-2">
              <ProfileIcon />
            </span>
            <span>{tcEvent.shipName}</span>
          </p>
          <p className="fw-bold">{this.props.t('requestUpdate.shippingSection.currentAddress')}</p>
          <p>
            <span className="pe-2">
              <LocationPin />
            </span>
            {tcEvent.shipAddress1 && <span className="pe-1">{tcEvent.shipAddress1},</span>}
            {tcEvent.shipAddress2 && <span className="pe-1">{tcEvent.shipAddress2},</span>}
            {tcEvent.shipAddress3 && <span className="pe-1">{tcEvent.shipAddress3},</span>}
            {tcEvent.shipCity && <span className="pe-1">{tcEvent.shipCity},</span>}
            {tcEvent.shipStateCode && <span className="pe-1">{tcEvent.shipStateCode}</span>}
            {tcEvent.shipPostalCode && <span className="pe-1">{tcEvent.shipPostalCode}</span>}
          </p>
        </div>
        <div className="pt-3">
          <h5 className="">{this.props.t('requestUpdate.shippingSection.newShippingInfoTitle')}</h5>
          <div className="pb-3">
            {this.props.t('requestUpdate.shippingSection.newShippingMessage')}
          </div>
          <Input
            containerClassName="shipping-name-input"
            type="text"
            name="shipToName"
            value={shippingAddress.shipToName}
            label="requestUpdate.shippingSection.shipToNameLabel"
            labelInfo={this.props.t('requestUpdate.shippingSection.shipToNameInfoLabel')}
            onChange={(e) => this.props.onShippingUpdate(e.target.name, e.target.value)}
            errors={errors.shipToName}
            isValueChanged={
              tcEvent.shipName
                ? shippingAddress.shipToName !== tcEvent.shipName
                : !isEmpty(shippingAddress.shipToName)
            }
            clearValue={() => this.onClearValue('shipToName')}
          />
          <Input
            containerClassName=""
            type="text"
            name="address1"
            value={shippingAddress.address1}
            label="requestUpdate.shippingSection.address1"
            onChange={(e) => this.props.onShippingUpdate(e.target.name, e.target.value)}
            errors={errors.address1}
            isValueChanged={
              tcEvent.shipAddress1
                ? shippingAddress.address1 !== tcEvent.shipAddress1
                : !isEmpty(shippingAddress.address1)
            }
            clearValue={() => this.onClearValue('address1')}
          />
          <Input
            containerClassName=""
            type="text"
            name="address2"
            label="requestUpdate.shippingSection.address2"
            value={shippingAddress.address2}
            onChange={(e) => this.props.onShippingUpdate(e.target.name, e.target.value)}
            errors={errors.address2}
            isValueChanged={
              tcEvent.shipAddress2
                ? shippingAddress.address2 !== tcEvent.shipAddress2
                : !isEmpty(shippingAddress.address2)
            }
            clearValue={() => this.onClearValue('address2')}
          />
          <Input
            containerClassName=""
            type="text"
            name="address3"
            label="requestUpdate.shippingSection.address3"
            labelInfo={this.props.t('common.labels.optional')}
            value={shippingAddress.address3}
            onChange={(e) => this.props.onShippingUpdate(e.target.name, e.target.value)}
            errors={errors.address3}
            isValueChanged={
              tcEvent.shipAddress3
                ? shippingAddress.address3 !== tcEvent.shipAddress3
                : !isEmpty(shippingAddress.address3)
            }
            clearValue={() => this.onClearValue('address3')}
          />
          <ZipForm
            address={shippingAddress}
            errors={errors}
            addressSavedValue={{
              city: tcEvent.shipCity || '',
              stateCode: tcEvent.shipStateCode || '',
              postalCode: tcEvent.shipPostalCode || '',
            }}
            handleChange={this.onChangeZipForm}
            clearValue={this.onClearValue}
          />
          <Textarea
            value={shippingAddress.notes}
            name="notes"
            label="requestUpdate.shippingSection.notesLabel"
            labelInfo={this.props.t('common.labels.optional')}
            maxLength={MESSAGE_MAX_LENGTH}
            onChange={(e) => this.props.onShippingUpdate(e.target.name, e.target.value)}
            clearValue={() => this.onClearValue('notes')}
            isValueChanged={!isEmpty(shippingAddress.notes)}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(ShippingTab);
ShippingTab.propTypes = {
  t: PropTypes.func.isRequired,
};

ShippingTab.defaultProps = {};
